import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PlanOfferCard } from 'cvlib';
import { hideEpg } from 'containers/Player/actions/optionButtons/epgButton.actions';
import { hideGrid } from 'containers/Player/actions/optionButtons/gridButton.actions';
import { hideEpgTransactions } from 'containers/Player/actions/epgTransactions/epgTransactions.actions';
import { setCurrentPBI } from 'action-creators/payway/currentPayment/currentPBI';
import {
  getWorkflowStart,
  clearWorkflowStart,
} from 'action-creators/payway/workflowStart';
import { checkIfProtectPaymentIsActive } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { GetRegion } from 'constants.js';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { getTranslation } from '../../../../utils/getTranslation';
import { getActionPaymentLink } from 'containers/Vcard/utils/redirect';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import './MultipleOffersScreen.scss';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { clearPurchaseButtonInfo } from 'action-creators/payway/purchaseButtonInfo';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

const MultipleOffersScreen = ({ wfscleared, setForceCallCenter }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const assets = useSelector(state => state.asset);
  const pbi = useSelector(state => state.payway.purchaseButtonInfo);
  const keyword =
    useSelector(state => state.search.searchResults.keyword) || '1';
  const isInPlayer = location?.pathname?.includes('watch');
  const { group_id } = pbi.data;

  const workflowStart = useSelector(state => state.payway.workflowStart);
  const user = useSelector(state => state.user);

  const [planClicked, setPlanClicked] = useState(null);
  const claroLiteConfig = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const isFreemiumUserNotLogged =
    user.userType === 'ANONYMOUS' && claroLiteConfig?.enable;

  useEffect(() => {
    if (workflowStart?.data !== null) {
      dispatch(clearWorkflowStart());
    }
  }, []);

  useEffect(
    () => {
      if (workflowStart?.inProgress === false && wfscleared === true) {
        const link = getActionPaymentLink({
          userType: user.userType,
          claroAdEnabled: claroLiteConfig?.enable,
        });
        let params = {
          player_url: ClaroUrlBuilder.player(group_id),
        };

        if (workflowStart.success) {
          if (user?.userType === 'ANONYMOUS') {
            const urlVcard = `/${GetRegion()}/watch/${group_id}?anonymousUserComeFromTransaction=${
              isInPlayer ? '0' : keyword
            }`;
            params = {
              ...params,
              group_id,
              oneoffertype: planClicked?.oneoffertype,
              oneofferdesc: planClicked?.oneofferdesc,
              linkworkflowstart: planClicked?.linkworkflowstart,
              urlVcard,
            };
            const planSelected =
              JSON.parse(sessionStorage.getItem('plan') || '') || '';
            const isBuyRentContent =
              planSelected?.oneoffertype === 'download_rent' ||
              planSelected?.oneoffertype === 'rent' ||
              planSelected?.oneoffertype === 'download_buy';
            if (isFreemiumUserNotLogged) {
              params.anonymousUser = 'true';
              localStorage.setItem('object_id', planSelected?.product_id);
              if (isBuyRentContent) {
                params.isBuyRentContent = 'true';
                localStorage.removeItem('object_id');
              }
            }
            dispatch(clearPurchaseButtonInfo());
          }

          dispatch(
            checkIfProtectPaymentIsActive({
              onSuccess: () =>
                navigate(
                  `${link}?${createSearchParams({
                    ...params,
                    groupId: group_id,
                    comeFromEpgTransactions: true,
                  })}`,
                  {
                    state: {
                      currentPBI: planClicked,
                      returnTo: group_id,
                    },
                  },
                ),
            }),
          );
          dispatch(hideEpg());
          dispatch(hideGrid());
          dispatch(hideEpgTransactions());
        }
      }
    },
    [workflowStart?.inProgress, workflowStart?.success],
  );

  if (pbi.success !== true) {
    return null;
  }

  const handleContractClick = plan => {
    if(plan?.price === "" && plan?.currency === "") {
      setForceCallCenter(true);
      return
    }
    sessionStorage.setItem('plan', JSON.stringify(plan));
    setPlanClicked(plan);
    dispatch(setCurrentPBI(plan));
    dispatch(getWorkflowStart(plan.linkworkflowstart));
  };

  const handleWhatIncludesClick = plan => {
    if (plan.family === 'grilla_reducida') {
      navigate(`/${GetRegion()}/planselect/prepago${location.search}`, {
        ...location,
        state: {
          ...location.state,
          groupId: group_id,
        },
      });
    } else {
      navigate(`${location.pathname.replace(/^(\/.*?\b\/).*$/, '$1planselect')}?${createSearchParams({
                    groupId: group_id,
                  })}`, {
        ...location,
        state: {
          ...location.state,
          whatContainsIsShown: true,
          planClicked: plan,
          groupId: group_id,
          comeFromEpgTransactions: true,
        },
      });
    }
    dispatch(hideEpg());
    dispatch(hideGrid());
    dispatch(hideEpgTransactions());
    return;
  };

  return (
    <div className="player-epg-transactions-modal">
      <h2 className="player-epg-transactions-title">
        {renderMaxLengthText(
          getTranslation(
            'Transaccionales_ContratacionCanalesMultiple_TextoTitulo',
            translations,
          ),
          53,
        )}
      </h2>
      <div className="player-epg-transactions-multiple-container">
        {pbi?.data?.listButtons?.button?.map(plan => (
          <PlanOfferCard
            onContractClicked={() => handleContractClick(plan)}
            onWhatIncludesClicked={() => handleWhatIncludesClick(plan)}
            image={
              assets[
                `Transaccionales_ContratacionCanalesMultiple_Tarjeta_ImagenFondo_${
                  plan?.producttype
                }`
              ]
            }
            logo={
              assets[
                `Transaccionales_ContratacionCanalesMultiple_Tarjeta_ImagenLogo_${
                  plan?.producttype
                }`
              ]
            }
            currency={plan?.currency}
            price={plan?.price}
            periodicity={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoTemporalidad_${
                plan?.producttype
              }`,
              translations,
            )}
            whatIncludes={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoBotonIncluye1_${
                plan?.producttype
              }`,
              translations,
            )}
            whatIncludes2={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoBotonIncluye2_${
                plan?.producttype
              }`,
              translations,
            )}
            contract={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoBoton1_${
                plan?.producttype
              }`,
              translations,
            )}
            contract2={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoBoton2_${
                plan?.producttype
              }`,
              translations,
            )}
            key={plan?.producttype}
            tax={getTranslation(
              `Transaccionales_TextoImpuestos_${plan?.producttype}`,
              translations,
            )}
            promotion1={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoPromocion1_${
                plan?.producttype
              }`,
              translations,
            )}
            promotion2={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoPromocion2_${
                plan?.producttype
              }`,
              translations,
            )}
            promotion3={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoPromocion3_${
                plan?.producttype
              }`,
              translations,
            )}
            whatIncludesColor={getTranslation(
              'Color_ColorQueIncluye',
              translations,
            )}
            contractColor={getTranslation(
              `Transaccionales_ContratacionCanalesMultiple_Tarjeta_ColorBotonSubscripcion_${
                plan?.producttype
              }`,
              translations,
            )}
          />
        ))}
      </div>
    </div>
  );
};
export default MultipleOffersScreen;
